import { Navigate, NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../../../context/AuthContext'
import { PERMISSION_KEYS } from '../../../config/permissions'
import { PageHeader, PageShell } from '../../../components/ui'
import { tabLink, tabsWrapClass } from '../../../lib/ui'

function CategoriesIndexRedirect() {
  const { can } = useAuth()
  if (can(PERMISSION_KEYS.CONSUMABLES_READ)) {
    return <Navigate to="/admin/administration/categories/consumables" replace />
  }
  if (can(PERMISSION_KEYS.PRODUCTS_READ)) {
    return <Navigate to="/admin/administration/categories/products" replace />
  }
  return <Navigate to="/admin/administration/panel" replace />
}

export { CategoriesIndexRedirect }

export function CategoriesLayout() {
  const { can } = useAuth()
  const showConsumables = can(PERMISSION_KEYS.CONSUMABLES_READ)
  const showProducts = can(PERMISSION_KEYS.PRODUCTS_READ)

  return (
    <PageShell>
      <PageHeader
        title="Категории"
        lead="Отдельные деревья для комплектации и готовой продукции. Удаление недоступно при вложенных категориях или привязанных записях."
      />
      <div className={tabsWrapClass}>
        {showConsumables && (
          <NavLink
            to="/admin/administration/categories/consumables"
            className={({ isActive }) => tabLink(isActive)}
          >
            Комплектация
          </NavLink>
        )}
        {showProducts && (
          <NavLink
            to="/admin/administration/categories/products"
            className={({ isActive }) => tabLink(isActive)}
          >
            Продукция
          </NavLink>
        )}
      </div>
      <div className="mt-5">
        <Outlet />
      </div>
    </PageShell>
  )
}
